import React, {lazy, Suspense} from 'react';

const TheDragDrop = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./DragDrop'));
const TheDraggable = lazy(
    () => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'@hello-pangea/dnd').then(module => ({ default: module.Draggable }))
);

const DragDrop = (props) => {
    return <Suspense fallback={null}>
        <TheDragDrop {...props} />
    </Suspense>
}


const Draggable = (props) => {
    return <Suspense fallback={null}>
        <TheDraggable {...props} />
    </Suspense>
}

export default DragDrop;

export {
    Draggable,
}
